<template>
  <div class="bear">
    <div class="header">
      <img
        src="/public/static/home/img/welcome.png"
        alt=""
      >
    </div>
    <div class="content">
      <!-- <Pressure :preparam="preParam" />
      <Free :freeparam="freeParam" />
      <Grateful :graparam="graParam" />
      <Atmosphere :atmparam="atmParam" /> -->
      <Currency v-for="(item, index) of dataList" :key="item.id" :atmparam="item" :index="index" />
    </div>
    <div
      class="mask"
      v-if="disNone"
    >
      <div class="mask-word">
        <p>点击右上角按钮</p>
        <p>选择“在Safari中打开”</p>
        <p>继续使用</p>
      </div>
    </div>
  </div>
</template>
<script>
// import Pressure from "../components/Pressure";
// import Atmosphere from "../components/Atmosphere";
// import Free from "../components/Free";
// import Grateful from "../components/Grateful";
import Currency from "../components/Currency";
export default {
  components: {
    // Pressure,
    // Grateful,
    // Atmosphere,
    // Free,
    Currency,
  },
  data () {
    return {
      preParam: {},
      freeParam: {},
      graParam: {},
      atmParam: {},
      disNone: false,
      dataList: [],
    }
  },
  created () {
    this.$server.postAPI('list').then(res => {
      console.log(res)
      localStorage.setItem('param', JSON.stringify(res));
      this.preParam = res[0];
      this.freeParam = res[1];
      this.graParam = res[2];
      this.atmParam = res[3];
      this.dataList = res.map((item) => {
        return {
          id: item.id,
          name: item.name,
          remark: item.remark,
          img: '/public/static/home/img/cover/' + item.id + '.png',
        }
      })

    })
    // 判断是不是ios
    // if(this.appSource() === "ios"){
    //   // this.disNone = true
    //   window.location.href = "index/main/main.html"
    // }
    // 判断是不是ios跳转的系统浏览器
    // let ua = window.navigator.userAgent.toLowerCase();
    // if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    //   this.disNone = true
    // }

  },
  methods: {
    appSource () {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        return "ios";
      } else {
        return "andriod";
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.bear {
  width: 100%;
  height: 100%;
  .header {
    width: 100%;
    height: 456px;
    img {
      max-width: 100%;
      width: 100%;
    }
  }
  .content {
    width: 960px;
    margin: auto;
    margin-top: 40px;
  }
  .mask {
    background: rgba(0, 0, 0, 0.75);
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    .mask-word {
      width: 750px;
      height: 300px;
      margin-top: 35vh;
      > p {
        display: block;
        width: 100%;
        text-align: center;
        font-size: 60px;
        color: #ffffff;
        margin-top: 50px;
      }
    }
  }
}
</style>
